function setGetElementByIdShim(webCompName: string) {
    if (typeof document !== 'undefined') {
        function getElementByIdFromShadowRoot(id: string): HTMLElement {
            const elems = document.getElementsByTagName(webCompName);
            // @ts-ignore
            const asArr = [...elems];
            const wcContainer = asArr[0];
            return wcContainer.shadowRoot.getElementById(id);
        }

        // @ts-ignore
        document._oldGetElementById = document.getElementById;
        document.getElementById = function (elemIdOrName) {
            // @ts-ignore
            var result = document._oldGetElementById(elemIdOrName);
            if (!result) {
                const elemFromShadow =
                    getElementByIdFromShadowRoot(elemIdOrName);
                if (elemFromShadow) {
                    result = elemFromShadow;
                }
            }

            return result;
        };
    }
}

// Hack from data-podlet-server because attachClickTrackers
// tries to document.getElementById, which fails since
// data-podlet-server is inside a web component
export function loadDivInDocumentAndRemove(
    targetId: string,
    callback: (HTMLElement) => void,
) {
    if (window.apntag && targetId) {
        const tempDiv = document.createElement('div');
        tempDiv.style.opacity = '0';
        tempDiv.style.width = '0px';
        tempDiv.style.height = '0px';
        tempDiv.style.position = 'absolute';
        tempDiv.style.bottom = '-200px';
        tempDiv.style.left = '-200px';

        tempDiv.setAttribute('id', targetId);
        document.body.appendChild(tempDiv);
        callback(tempDiv);
        setTimeout(() => {
            document.body.removeChild(tempDiv);
        }, 2000);
    }
}
